import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';

import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { ChipsComponent } from '~/component/chips/chips.component';

@Component({
  selector: 'app-attendee-chips-filter',
  templateUrl: './chips-filter.component.html',
  styleUrls: ['./chips-filter.component.scss'],
})
export class AttendeeChipsFilterComponent {
  @Input() public buttonText: string;
  @Input() public dialogTitle?: string;
  @Input() public hasSelectedFilters: boolean;
  @Input() public isValidButtonDisabled = false;

  @Output() public resetChipsFilter = new EventEmitter<void>();
  @Output() public updateChipsFilter = new EventEmitter<void>();

  @ViewChild('chipsComponent') public chipsComponent: ChipsComponent;

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public resetAndClose(): void {
    this.resetChipsFilter.emit();
    this.chipsComponent.toggleDialog();
  }

  public updateAndClose(): void {
    this.updateChipsFilter.emit();
    this.chipsComponent.toggleDialog();
  }
}
